var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("activator",function(){return [_c('v-btn',{attrs:{"title":_vm.$vuetify.lang.t('$vuetify.logout')},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("mdi-logout")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.logout'))+" ")],1)]},{"logout":_vm.logout})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }